import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { Menu, X } from 'lucide-react';

export function NavItemPlain({ url, children, className = '', disableHover = false }) {
  return (
    <Link
      to={url}
      className={`block px-3 py-2 rounded-md ${!disableHover ? 'hover:bg-gray-100' : ''} ${className}`}
    >
      {children}
    </Link>
  );
}

function Navigation() {
  const { user, isLoggedIn } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Close menu when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Debugging
  useEffect(() => {
    console.log("isLoggedIn:", isLoggedIn);
    console.log("user:", user);
  }, [isLoggedIn, user]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-customColor1 sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="../image/sidekick-logo.png" 
              alt="Sidekick Logo" 
              className="h-8 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 font-museo">
            <Link to="/" className="nav-item hover:text-gray-300">
              Home
            </Link>
            <Link to="/feature" className="nav-item hover:text-gray-300">
              Features
            </Link>
            <Link to="/contact" className="nav-item hover:text-gray-300">
              Contact
            </Link>
            <Link to="/about" className="nav-item hover:text-gray-300">
              About Us
            </Link>
            {isLoggedIn && user ? (
              <NavItemPlain url="/profile" disableHover>
                {user.name || 'Profile'}
              </NavItemPlain>
            ) : (
              <NavItemPlain url="/login" disableHover>Login</NavItemPlain>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-gray-500 hover:bg-gray-100 focus:outline-none"
            >
              {isOpen ? (
                <X className="block h-6 w-6 text-white hover:text-gray-700" />
              ) : (
                <Menu className="block h-6 w-6 text-white hover:text-gray-700" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-customColor1">
            <Link to="/" className="block px-3 py-2 rounded-md hover:bg-gray-100 hover:text-gray-700">
              Home
            </Link>
            <Link to="/feature" className="block px-3 py-2 rounded-md hover:bg-gray-100 hover:text-gray-700">
              Features
            </Link>
            <Link to="/contact" className="block px-3 py-2 rounded-md hover:bg-gray-100 hover:text-gray-700">
              Contact
            </Link>
            <Link to="/about" className="block px-3 py-2 rounded-md hover:bg-gray-100 hover:text-gray-700">
              About Us
            </Link>
            {isLoggedIn && user ? (
              <NavItemPlain url="/profile" className="hover:text-gray-700">{user.name || 'Profile'}</NavItemPlain>
            ) : (
              <NavItemPlain url="/login" className="hover:text-gray-700">Login</NavItemPlain>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;